import React from "react"
import WithData from "containers/WithData"
import Loaded from "./CampProfile"
import Loading from "./CampProfile.loading"

import glamorous from "glamorous"
import style from "utils/style"

class CampProfile extends React.Component {
  render() {
    const { match } = this.props

    return (
      <WithData
        route={`camps/${match.params
          .id}?include=camp-specialties,camp-expertises`}
        LoadingComponent={Loading}
      >
        <Loaded />
      </WithData>
    )
  }
}

export default CampProfile

export const Body = glamorous.div(
  {
    display: "flex",
    flexWrap: "wrap",
    whiteSpace: "nowrap",
    paddingTop: "1%",
    [style.size.desktop]: {
      flexWrap: "wrap",
    },
  },
  ({ wrap }) => ({
    flexWrap: wrap ? "wrap" : "initial",
  })
)

export const BulletItem = glamorous.span({
  color: style.colors.almostBlack,
  fontSize: "0.9rem",
  flexWrap: "wrap",
  width: "50%",
  marginBottom: "1rem",
  [style.size.desktop]: {
    width: "100%",
  },
  "&::before": {
    content: "•",
    paddingRight: "1%",
  },
})

export const StyledLink = glamorous.a({
  textDecoration: "none",
  fontWeight: "bold",
  color: style.colors.darkGreen,
  fontSize: "0.9rem",
  width: "100%",
  flexWrap: "wrap",
  "&:hover": {
    color: style.colors.green,
  },
})

export const BriefDescription = glamorous.span({
  paddingBottom: "2rem",
  color: style.colors.almostBlack,
})

export const CampInformation = glamorous.div({
  display: "flex",
  flexDirection: "column",
})

export const CampExpertise = glamorous.div({
  display: "flex",
  flexDirection: "column",
})

export const CampSpecialty = glamorous.div({
  display: "flex",
  flexDirection: "column",
})

export const FullDescription = glamorous.span({
  color: style.colors.almostBlack,
})

export const Header = glamorous.div(
  {
    display: "flex",
    flexDirection: "column",
    padding: "2rem 0 2rem 0",
  },
  ({ loading }) => ({
    filter: loading && "blur(5px)",
  })
)

export const Info = glamorous.div({
  display: "flex",
  flexDirection: "column",
  paddingBottom: "2rem",
})

export const InfoColumn = glamorous.div({
  display: "flex",
  justifyContent: "spcae-between",
  flexDirection: "column",
  width: "100%",
})

export const InfoTitle = glamorous.span({
  color: style.colors.silver,
  textTransform: "uppercase",
  fontWeight: "bold",
  fontSize: "0.8rem",
  paddingBottom: "0.5rem",
})

export const InfoDetail = glamorous.span({
  color: style.colors.almostBlack,
  fontSize: "0.9rem",
  paddingBottom: "0.5rem",
})

export const Segment = glamorous.div(
  {
    width: "100%",
    padding: "1rem",
    borderRadius: 8,
    overflow: "scroll",
  },
  ({ backgroundColor, loading }) => ({
    backgroundColor: backgroundColor || "white",
    filter: loading && "blur(5px)",
  })
)

export const Title = glamorous.span({
  color: style.colors.green,
  paddingBottom: "1rem",
  fontSize: "1.2rem",
  fontWeight: "bold",
})



// WEBPACK FOOTER //
// ./src/scenes/Camp/CampProfile/index.js